//@ts-nocheck
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { putApiData } from "../helpers/AxiosInstance";
import { toast } from "react-toastify";
import { useNavigate } from "react-router-dom";

const usePatchHook = ({ queryKey, navigateURL, message = true }) => {
  const queryClient = useQueryClient();
  const navigate = useNavigate();

  const { isPending, mutateAsync, isSuccess, data, isError, isLoading } =
    useMutation({
      mutationFn: putApiData,
      onSuccess: (data) => {
        if (data?.status === 200) {
          if (message) {
            toast.success("Updated successfully");
          }
          if (navigateURL) {
            navigate(navigateURL);
          }
        }
      },
      onError: (error: any) => {
        console.error(error);
      },
      onSettled: () => {
        queryClient.invalidateQueries(queryKey);
      },
    });

  return {
    isPending,
    mutateAsync,
    isSuccess,
    data,
    isError,
    isLoading,
  };
};

export default usePatchHook;
